import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@hub/helpers/use-store';
import InactiveDaysRule from '../account-rules/inactive-days/inactive-days-rule';
import InactiveDaysProgress from '../progress-cards-5ers/inactive-days-progress';

export enum DashboardCardType {
  Rule = 'rule',
  Progress = 'progress',
}

interface Props {
  accountId: string;
  programId: string;
  type: DashboardCardType;
  consecutiveInactivityDays: number;
  isLoading?: boolean;
}

export interface InactiveDayCardProps {
  inactivityDays: number;
  maxInactiveDays: number;
  tooltipText: string;
  isLoading?: boolean;
}

const InactiveDays: FunctionComponent<Props> = ({
  programId,
  type,
  consecutiveInactivityDays = 0,
  isLoading,
}) => {
  const {
    dataStore: { programStore },
  } = useStore();
  const { t } = useTranslation(['dashboardTemplates']);

  const program = programStore.get(programId);

  const maxInactiveDays = program?.config?.inactivityDays || 0;

  const tooltipText = t('dashboardTemplates:account_expiration_notice', {
    value: maxInactiveDays,
  });

  const InactiveDayCard =
    type === DashboardCardType.Rule ? InactiveDaysRule : InactiveDaysProgress;

  return (
    <InactiveDayCard
      inactivityDays={consecutiveInactivityDays}
      maxInactiveDays={maxInactiveDays}
      tooltipText={tooltipText}
      isLoading={isLoading}
    />
  );
};

export default InactiveDays;
